import * as PIXI from 'pixi.js'
import prefix from 'prefix'
import * as math from 'utils/math.js'
import Detector from 'utils/Detector'
import TweenMax from 'gsap'
import Emitter from 'core/Emitter'

export default class FlowerParticles {
  constructor (opts) {
    this.bindAll()
    this.parent = opts.parent
    this.size = Detector.getScreenSize()
    this.currentFlower = null
    this.particles = []
    this.particlesClones = []
    this.totalParticles = (Detector.isMobile()) ? 50 : 70
    this.dustBoundsPadding = 20
    this.dustBounds = new PIXI.Rectangle(this.dustBoundsPadding, this.dustBoundsPadding, this.size.w - this.dustBoundsPadding * 2, this.size.h - this.dustBoundsPadding * 2)

    let particlesContainerOpts = {
      scale: true,
      position: true,
      rotation: true,
      uvs: true,
      alpha: true
    }

    this.particlesContainer = new PIXI.particles.ParticleContainer(1000, particlesContainerOpts)
    this.particlesContainer2 = new PIXI.particles.ParticleContainer(1000, particlesContainerOpts)

    this.isShowed = false
    this.isShowing = false
    this.particlesContainer.alpha = 0
    this.particlesContainer2.alpha = 0

    this.parent.scene.addChild(this.particlesContainer)
    this.parent.scene.addChild(this.particlesContainer2)

    this.createParticles()

    this.addListeners()
  }

  showParticles (flower) {
    if (this.currentFlower === flower.indexFlower) return
    this.currentFlower = flower.indexFlower

    this.canHideParticles = false

    this.fixtimeout = setTimeout(() => {
      this.canHideParticles = true
    }, 100)

    this.positionParticles(flower)

    if (this.tweenShow) {
      this.tweenShow.isActive() && this.tweenShow.kill()
    }

    if (this.tweenHide) {
      if (!this.tweenHide.isActive()) {
        // this.particlesContainer2.alpha = 0
      }
    }

    this.tweenShow = TweenMax.to(this.particlesContainer, 2, {
      alpha: 1,
      ease: Quint.easeOut,
      onComplete: () => {}
    })

    /**
    if (!this.isHiding) {
      this.particlesContainer2.alpha = 0
    }
    this.isHidden = false
    // this.tweenHide && this.tweenHide.kill()
    // this.isHiding = false
    // this.isHidden = false

    this.currentFlower = flower.indexFlower
    this.isShowing = true

    this.positionParticles(flower)

    this.particlesContainer.alpha = 0

    this.tweenShow = TweenMax.to(this.particlesContainer, 2, {
      alpha: 1,
      ease: Expo.easeOut,
      onComplete: () => {
        console.log(':: on complete this.tweenShow')
        this.isShowed = true
        this.isShowing = false
        this.isHidden = false
        this.isHiding = false
      }
    })
    */
  }

  hideParticles (flower) {
    if (!this.canHideParticles) return

    if (this.tweenShow) {
      this.tweenShow.isActive() && this.tweenShow.kill()
    }

    if (this.currentFlower === flower.indexFlower) {
      this.currentFlower = null

      for (let i = 0; i < this.particlesClones.length; i++) {
        let dust = this.particles[i]
        let dustClone = this.particlesClones[i]
        dustClone.position.x = dust.position.x
        dustClone.position.y = dust.position.y
        dustClone.alpha = dust.alpha
        dustClone.scale.set(dust.scale.x)
      }
    }

    this.particlesContainer.alpha = 0
    this.particlesContainer2.alpha = 1

    this.tweenHide = TweenMax.to(this.particlesContainer2, 1.5, {
      alpha: 0,
      ease: Expo.easeIn,
      onComplete: () => {}
    })

    /**
    if (this.isHiding || this.isHidden) return

    this.currentFlower = null
    this.tweenShow && this.tweenShow.isActive() && this.tweenShow.kill()
    this.tweenHide && this.tweenHide.isActive() && this.tweenHide.kill()
    this.isShowing = false

    this.isHiding = true
    this.isHidden = false
    this.particlesContainer.alpha = 0
    this.particlesContainer2.alpha = 1

    for (let i = 0; i < this.particlesClones.length; i++) {
      let dust = this.particles[i]
      let dustClone = this.particlesClones[i]
      dustClone.position.x = dust.position.x
      dustClone.position.y = dust.position.y
      dustClone.alpha = dust.alpha
      dustClone.scale.set(dust.scale.x)
    }

    this.tweenHide = TweenMax.to(this.particlesContainer2, 1.5, {
      alpha: 0,
      ease: Expo.easeIn,
      onComplete: () => {
        console.log(':: on complete this.tweenHide')
        this.isHidden = true
        this.isHiding = false
      }
    })

    // if (this.isHiding || this.isHidden) return
    /**

    for (let i = 0; i < this.particlesClones.length; i++) {
      let dust = this.particles[i]
      let dustClone = this.particlesClones[i]
      dustClone.position.x = dust.position.x
      dustClone.position.y = dust.position.y
      dustClone.alpha = dust.alpha
      dustClone.scale.set(dust.scale.x)
    }

    this.isHiding = true

    this.timeoutHide && window.clearTimeout(this.timeoutHide)

    this.particlesContainer.alpha = 0
    this.particlesContainer2.alpha = 1

    TweenMax.to(this.particlesContainer2, 2, {
      alpha: 0,
      ease: Expo.easeOut,
      onComplete: () => {
        this.isHidden = true
        this.isHiding = false
        this.isShowed = false
      }
    })
    **/
  }

  bindAll () {
    ['showParticles', 'hideParticles']
    .forEach((fn) => (this[fn] = this[fn].bind(this)))
  }

  addListeners () {
    Emitter.on('SHOW_PARTICLES', this.showParticles)
    Emitter.on('HIDE_PARTICLES', this.hideParticles)
  }

  removeListeners () {
    Emitter.removeListener('SHOW_PARTICLES', this.showParticles)
    Emitter.removeListener('HIDE_PARTICLES', this.hideParticles)
  }

  createParticles (particlesContainer) {
    for (var i = 0; i < this.totalParticles; i++) {
      // create a new Sprite
      let dust = new PIXI.Sprite(PIXI.Texture.fromFrame(`little_particle`))
      // set the anchor point so the texture is centerd on the sprite
      dust.anchor.set(0.5)
      // different maggots, different sizes
      let maxScale = (i % 10 === 0) ? 2 : 1
      let scale = Math.max(0.04, Math.random() * maxScale)
      dust.scale.set(scale)
      // scatter them all
      dust.position.x = Math.random() * this.size.w
      dust.position.y = Math.random() * this.size.h
      // create a random direction in radians
      dust.direction = Math.random() * Math.PI * 2
      // this number will be used to modify the direction of the sprite over time
      dust.turningSpeed = Math.random() - 0.8
      // create a random speed between 0 - 2, and these maggots are slooww
      // dust.speed = (4 + Math.random() * 4) * 0.8
      dust.speed = (scale > 0.08) ? (2 + Math.random() * 2) * 0.3 : (4 + Math.random() * 4) * 0.8
      dust.offset = Math.random() * 100
      dust.maxAlpha = (scale > 0.08) ? Math.random() * 0.3 : Math.random() * 0.8
      dust.maxAlpha = Math.max(0.1, dust.maxAlpha)
      // finally we push the dust into the maggots array so it it can be easily accessed later
      this.particles.push(dust)
      this.particlesContainer.addChild(dust)
    }

    this.particles.forEach((dust) => {
      // console.log(dust)
      let dustClone = new PIXI.Sprite(PIXI.Texture.fromFrame(`little_particle`))
      dustClone.anchor.set(0.5)
      dustClone.scale.set(dust.scale.x)
      dustClone.position.x = dust.x
      dustClone.position.y = dust.y
      dustClone.direction = dust.direction
      dustClone.turningSpeed = dust.turningSpeed
      dustClone.speed = dust.speed
      dustClone.offset = dust.offset
      dustClone.maxAlpha = dust.maxAlpha
      this.particlesClones.push(dustClone)
      this.particlesContainer2.addChild(dustClone)
    })
  }

  positionParticles (flower) {
    this.size = {
      w: flower.width,
      h: flower.height
    }

    // this.size.w - this.dustBoundsPadding * 2
    let space = this.size.w - (this.size.w - this.dustBoundsPadding * 2)
    let spaceY = this.size.h - (this.size.h - this.dustBoundsPadding * 2)
    let offsetX = (flower.x + (this.size.w / 2) - space / 2)
    let offsetY = (flower.y + ((this.size.h * 0.5)))
    this.dustBounds = new PIXI.Rectangle(offsetX + this.dustBoundsPadding, offsetY, this.size.w - this.dustBoundsPadding * 2, this.size.h * 0.4)

    for (let i = 0; i < this.particles.length; i++) {
      let dust = this.particles[i]
      // dust.scale.y = 0.95 + Math.sin(time + dust.offset) * 0.05
      dust.position.x = offsetX + math.random(-1, 1) * this.size.w * 0.2
      dust.position.y = offsetY + math.random(-1, 1) * this.size.h * 0.2

      // if (this.particlesContainer2.alpha === 0) {
      //   dustClone.x = dust.x
      //   dustClone.x = dust.y
      // }
    }
  }

  update (time) {
    if (this.particlesContainer.alpha === 0 && this.particlesContainer2.alpha === 0) return

    for (var i = 0; i < this.particles.length; i++) {
      var dust = this.particles[i]
      var dustClone = this.particlesClones[i]
      // dust.scale.set(0.03 + (Math.sin(time * (dust.speed / 10))) * 0.03)

      dust.direction += dust.turningSpeed * 0.05
      dust.position.x += Math.sin(dust.direction) * (dust.speed * dust.scale.y)
      dust.position.y += Math.cos(dust.direction) * (dust.speed * dust.scale.y)

      dust.alpha = Math.max(1, Math.sin(time * dust.turningSpeed) * dust.maxAlpha)

      if (this.particlesContainer2.alpha !== 0) {
        dustClone.direction += dustClone.turningSpeed * 0.05
        dustClone.x += Math.sin(dustClone.direction) * (dustClone.speed * dustClone.scale.y)
        dustClone.position.y += Math.cos(dustClone.direction) * (dustClone.speed * dustClone.scale.y)

        dustClone.alpha = Math.sin(time * dustClone.turningSpeed) * dustClone.maxAlpha
      }
    }
  }

  destroy () {
    this.tweenShow && this.tweenShow.eventCallback('onComplete', null)
    this.tweenShow && this.tweenShow.kill()
    this.tweenHide && this.tweenHide.eventCallback('onComplete', null)
    this.tweenHide && this.tweenHide.kill()
    this.removeListeners()
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/FlowerParticles.js
 **/